// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/Competitions/components/index.css
// module id = 2457
// module chunks = 0